import {SelectableTag} from "../api/models/SelectableTag"

export class TagsHelper {
    static switchSelection(tags: SelectableTag[], syncItem: SelectableTag) {
        tags.forEach(item => {
            if (item.tag.id === syncItem.tag.id) {
                item.isSelected = !syncItem.isSelected;
            }
        });
    }

    static saveToLocalStorage(tags: SelectableTag[], lsKey: string) {
        localStorage.setItem(lsKey, JSON.stringify(tags.filter(item => item.isSelected).map(item => item.tag.id)));
    }

    static getTagsIdsFromLocalStorage(lsKey: string) {
        return localStorage.getItem(lsKey);
    }
}